import {Box, Title} from '@mantine/core';
import type {FC} from 'react';
import {MdForum} from 'react-icons/md';
import {useGetCommunityTopicsHeadline} from '../../../core/repositories/communityRepository';
import {useAuth} from '../../../core/usecases/auth/AuthContext';
import {CommonLink} from '../CommonLink';

type Props = Record<string, unknown>;

export const PcCommunityTopicsHeadline: FC<Props> = () => {
  const {status} = useAuth();
  const {data} = useGetCommunityTopicsHeadline({
    config: {enabled: status === 'authenticated'},
  });
  if (!data) return null;

  return (
    <Box>
      <Title
        order={2}
        className="select-none bg-primary-1 p-8 text-base text-white-1"
      >
        コミュニティの新着質問
      </Title>
      <Box className="shadow-md bg-white font-bold">
        {data?.ok ? (
          data.value.topics.map((topic) => (
            <Box
              key={topic.id}
              className="border-b-1 mx-16 flex border  border-x-0 border-t-0 py-12"
            >
              <div className="w-1/8 p-4 text-primary-1">
                <MdForum />
              </div>
              <CommonLink
                className="w-7/8 cursor-pointer text-base text-black-1 hover:text-primary-3 hover:underline"
                href={`/questions/${topic.id}`}
              >
                {topic.title}
              </CommonLink>
            </Box>
          ))
        ) : (
          <div className="font-normal">Loading...</div>
        )}
      </Box>
    </Box>
  );
};
